import { gptUrl } from '../constants.ts';

let gptLoader: Promise<void> | null = null;

export const loadGpt = (): Promise<void> => {
    if (gptLoader) {
        return gptLoader;
    }

    gptLoader = new Promise<void>((resolve, reject) => {
        if (!window) {
            reject(new Error('DOM not available'));
            return;
        }
        const onLoad = (): void => {
            if (window.googletag) {
                window.googletag.cmd.push(() => {
                    const gptVersion = window.googletag.getVersion();
                    // Genuine GPT returns a version number, spoofed GPT returns empty string
                    if (gptVersion) {
                        resolve();
                    } else {
                        reject(new Error('window.googletag is spoofed'));
                    }
                });
            } else {
                reject(new Error('window.googletag is not available'));
            }
        };
        if (window.googletag && window.googletag.apiReady) {
            onLoad();
        } else {
            const script = document.createElement('script');
            script.async = true;
            script.onload = onLoad;
            script.onerror = () => {
                reject(new Error('failed to load script'));
            };
            script.src = gptUrl;
            document.head.appendChild(script);
        }
    });

    return gptLoader;
};
